import type { WalletTotpEnrollmentMaterial } from '@/features/wallet-mfa/wallet-mfa-types';

const KEY_FILE_NAME = 'gamma-wallet-authenticator-key.txt';

const keyFileText = ({ sharedSecret, setupUri }: WalletTotpEnrollmentMaterial): string =>
  [
    'Gamma wallet authenticator setup key',
    '',
    `Setup key: ${sharedSecret}`,
    `Setup link: ${setupUri}`,
    '',
    'To restore your authenticator on a new phone, add an account in your authenticator app and enter the setup key or open the setup link.',
    '',
    'Keep this file private. Anyone with this key can generate your wallet authenticator codes.',
    '',
  ].join('\n');

export const downloadWalletTotpKey = (material: WalletTotpEnrollmentMaterial): void => {
  const url = URL.createObjectURL(new Blob([keyFileText(material)], { type: 'text/plain' }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = KEY_FILE_NAME;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};
